export const AUTH_TOKEN = 'eddo-auth-token'